import type { PricingPerk } from './types';
import { FILE_SIZE_LIMIT_MB_PAID_TIER, FILE_SIZE_LIMIT_MB_PERSONAL_TIER } from '~/utils/constants';
import { formatTokens } from '~/utils/format';
import type { Pricing } from '~/utils/pricing';

export const FREE_PRICING_TOKENS = {
  daily: 150_000,
  monthly: 1_000_000,
};

export const FREE_PLAN_PERKS: PricingPerk[] = [
  'Public and private projects',
  `${formatTokens(FREE_PRICING_TOKENS.daily)} tokens daily limit`,
  `${formatTokens(FREE_PRICING_TOKENS.monthly)} tokens per month`,
  'Bolt branding on websites',
  `${FILE_SIZE_LIMIT_MB_PERSONAL_TIER}MB file upload limit`,
  'Website hosting',
  'Up to 333k web requests',
];

export const getProPlansPerks = ({
  shouldDisplayExactTierTokens,
  pricing,
}: {
  shouldDisplayExactTierTokens: boolean;
  pricing: Pricing;
}): PricingPerk[] => {
  return [
    'Public and private projects',
    'No daily token limit',
    shouldDisplayExactTierTokens ? `${pricing.tokens} tokens per month` : 'Start at 10M tokens per month',
    'No bolt branding on websites',
    `${FILE_SIZE_LIMIT_MB_PAID_TIER}MB file upload limit`,
    'Website hosting',
    'Up to 1M web requests',
    {
      text: 'Unused tokens roll over to next month',
      tooltip: 'Unused tokens roll over for one month only and require an active subscription to use them.',
    },
    'Custom domain support',
    'SEO boosting',
  ];
};

export const INVITE_TOKEN_SEARCH_PARAM = 'inviteToken';
export const INVITE_TO_TEAM_SEARCH_PARAM = 'inviteToTeam';

export const TEAM_PLAN_PERKS: PricingPerk[] = [
  'Centralized billing',
  'Team-level access management',
  'Granular admin controls & user provisioning',
  'Private NPM registries support',
  'Design System knowledge with per-package prompts',
];

export const SUBSCRIPTION_UPDATE_SEARCH_PARAM = 'subscription-update-message';

export const SHOW_TEAM_SETTINGS_PARAM = 'showTeamSettings';

export const SHOW_PRICING_OVERLAY_PARAM = 'showPricing';
